import { openCookiePreferences } from '@/shared/utils/cookiePreferences'

const logoUrl = 'https://www.160drivingacademy.com/wp-content/uploads/2026/08/w-logo.svg'
const currentYear = new Date().getFullYear()

const footerColumns = [
  {
    title: 'Explore',
    links: [
      { label: 'Enroll Now', href: 'https://www.160drivingacademy.com/register/' },
      { label: 'Locations', href: 'https://www.160drivingacademy.com/locator/' },
      {
        label: 'Placement',
        href: 'https://www.160drivingacademy.com/truck-driving-school-benefits/job-placement/'
      },
      {
        label: 'Endorsements',
        href: 'https://www.160drivingacademy.com/endorsements/'
      },
      {
        label: 'Funding',
        href: 'https://www.160drivingacademy.com/flexible-ways-to-pay/wioa-funding/'
      },
      {
        label: 'Privacy Policy',
        href: 'https://www.160drivingacademy.com/privacy-policy/'
      },
      {
        label: 'Terms of Service',
        href: 'https://www.160drivingacademy.com/terms-of-service/'
      }
    ]
  },
  {
    title: 'Company',
    links: [
      { label: 'About Us', href: 'https://www.160drivingacademy.com/about-us/' },
      { label: 'News', href: 'https://www.160drivingacademy.com/news/' },
      { label: 'Reviews', href: 'https://www.160drivingacademy.com/reviews/' },
      { label: 'Careers', href: 'https://www.160drivingacademy.com/careers/' },
      {
        label: 'Non-discrimination',
        href: 'https://www.160drivingacademy.com/non-discrimination/'
      },
      {
        label: 'Contact Us',
        href: 'https://www.160drivingacademy.com/contact-us/'
      }
    ]
  },
  {
    title: 'Quick Links',
    links: [
      {
        label: 'Tuition Reimbursement',
        href: 'https://www.160drivingacademy.com/tuition-reimbursement/'
      },
      {
        label: 'Register for Training',
        href: 'https://www.160drivingacademy.com/register/'
      },
      {
        label: 'CDL Test Prep',
        href: 'https://www.160drivingacademy.com/truck-driving-classes/cdl-test/'
      },
      {
        label: 'FAQ',
        href: 'https://www.160drivingacademy.com/why-choose-160/faq/'
      },
      { label: 'Gallery', href: 'https://www.160drivingacademy.com/gallery/' }
    ]
  },
  {
    title: 'CDL Resources',
    links: [
      {
        label: 'Benefits',
        href: 'https://www.160drivingacademy.com/truck-driving-school-benefits/'
      },
      {
        label: 'CDL Career Guidance',
        href: 'https://www.160drivingacademy.com/truck-driving-school-benefits/job-placement/'
      },
      {
        label: 'CDL Training',
        href: 'https://www.160drivingacademy.com/truck-driving-classes/cdl-classes/'
      },
      {
        label: 'Take a CDL Test',
        href: 'https://www.160drivingacademy.com/truck-driving-classes/cdl-test/'
      }
    ]
  }
] as const

export function SiteFooter() {
  return (
    <footer className="academy-site-footer" id="footer">
      <div className="academy-site-footer__top">
        <section className="academy-site-footer__brand">
          <img
            className="academy-site-footer__logo"
            src={logoUrl}
            alt="160 Driving Academy"
            width="175"
            height="60"
          />
          <strong>Corporate</strong>
          <address>5990 W Touhy Ave, Niles, IL 60714</address>
          <a href="mailto:customercare@160drivingacademy.com">customercare@160drivingacademy.com</a>
        </section>

        <section className="academy-site-footer__find">
          <h2>Find schools near you</h2>
          <p>Enter your ZIP code to find your nearest school.</p>
          <form action="https://www.160drivingacademy.com/locator/#schools-map" method="get">
            <label htmlFor="academy-school-zip">ZIP code</label>
            <div>
              <input
                id="academy-school-zip"
                name="dc_zip"
                inputMode="numeric"
                autoComplete="postal-code"
                pattern="[0-9]{5}(-?[0-9]{4})?"
                maxLength={10}
                required
              />
              <button type="submit">Find schools</button>
            </div>
          </form>
        </section>
      </div>

      <div className="academy-site-footer__columns">
        {footerColumns.map(column => (
          <nav aria-label={column.title} key={column.title}>
            <h2>{column.title}</h2>
            <ul>
              {column.links.map(link => (
                <li key={link.label}>
                  <a href={link.href}>{link.label}</a>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      <div className="academy-site-footer__bar">
        <span>© 2013–{currentYear}. 160 Driving Academy — License Number: #000312</span>
        <button type="button" onClick={openCookiePreferences}>
          Cookie preferences
        </button>
      </div>
    </footer>
  )
}
